export default function extractTextContent(htmlStr) {
	const htmlEl = document.createElement('span');
	htmlEl.innerHTML = htmlStr;
	return htmlEl.textContent || htmlEl.innerText;
}
